import { put, select, take } from 'redux-saga/effects';
import { apiAction, get, mapStateToArgs } from 'ctm-util-functions';

/**
 * Run the API onMount actions for a page.
 * This is slow because each action makes an async API call.
 *
 * @param {Object} page - Current journey page.
 * @param {Object} pageState - Tightly coupled to PageWrapper mapStateToProps(), it has all page settings.
 */
export const runApiOnMountForPage = function* (page, pageState) {
    // Run the onMount action for the current page.
    const apiOnMount = get(page, 'api.onMount');
    if (apiOnMount) {
        const restArgs = yield select(mapStateToArgs, apiOnMount.restArgs);
        if (apiOnMount.queryStringArgs) {
            apiOnMount.queryStringValues = yield select(mapStateToArgs, apiOnMount.queryStringArgs);
        }
        const action = apiAction(apiOnMount, pageState, restArgs, apiOnMount.baseUrl);
        yield put(action);
        yield take(`${action.type}_SUCCESS`);
    }
};
